import { Component, OnDestroy, OnInit } from '@angular/core';
import { SnackbarService } from "../../shared/services/snackbar.service";
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { ResetPasswordService } from "./reset-password.service";

@Component({
  selector: 'reset-password',
  template: require('./reset-password.component.html'),
  styles: [require('./reset-password.component.less')],
  providers: [SnackbarService, ResetPasswordService],
  preserveWhitespaces: true
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  passwordDetails: any = {};
  valueRequired: boolean = false;
  key: string;
  private _userRole: string;
  isValid: boolean = false;

  resetSubscription: Subscription;

  constructor(
    private _mdlSnackbarService: SnackbarService,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _resetPasswordService: ResetPasswordService
  ) {
  }

  resetPassword = (passwordDetails: any) => {
    let passwordPattern = new RegExp(/(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_])^.{6,}$/);
    if (passwordDetails.confirm_password && passwordDetails.new_password) {
      if (passwordPattern.test(passwordDetails.new_password)) {
        this.verifyPassword(passwordDetails);
      } else {
        this._mdlSnackbarService.showSnackbar('PASSWORD_WRONG_FORMAT', 'error');
      }
    } else {
      this.valueRequired = true;
      this._mdlSnackbarService.showSnackbar('FILL_REQUIRED_DETAILS', 'error');
    }
  }

  verifyPassword(passwordDetails: any) {
    if (passwordDetails.confirm_password !== passwordDetails.new_password) {
      this._mdlSnackbarService.showSnackbar("PASSWORD_NOT_MATCH", 'error');
    } else {
      let resetPasswordValue = {
        key: this.key,
        password: passwordDetails.new_password
      }

      this.resetSubscription?.unsubscribe();
      this.resetSubscription = this._resetPasswordService.resetPassword(resetPasswordValue).
        subscribe((res: any) => {
          if (res.status === 'ok') {
            this._mdlSnackbarService.showSnackbar('PASSWORD_UPDATE_SUCCESS', 'success');
            this._router.navigate(['login']);
          } else {
            this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error');
          }
        },
          error => this._mdlSnackbarService.showSnackbar('SOMETHING_WENT_WRONG', 'error'));
    }
  }

  ngOnInit() {
    this._activatedRoute.params.subscribe(params => {
      this.key = params['token'];
      this._resetPasswordService.ValidateToken(this.key).
        subscribe((res: any) => {
          this.isValid = true;
        },
          error => {
            this._router.navigate(['404']);
          })
    });
  }

  ngOnDestroy() {
    this.resetSubscription?.unsubscribe();
  }
}
